module.exports = __webpack_public_path__ + "img/mistockdark.49728833.png";